import React from 'react';
import { styled } from '@teko/ui';

const Field = styled.p`
  line-height: 20px;
  margin-bottom: 0;
`;
const Key = styled.span`
  font-size: 14px;
  font-weight: 700;
`;
const Value = styled.span(({ color }) => `
    font-weight: 400;
    color: ${color}
`);
const DetailInfo = ({
  field,
  color = "#333",
  value
}) => /* @__PURE__ */ React.createElement(Field, null, /* @__PURE__ */ React.createElement(Key, null, field, ": "), /* @__PURE__ */ React.createElement(Value, {
  color
}, value));

export { DetailInfo };
